export default __webpack_public_path__ + "f3bbb74.png";